import { noop } from 'lodash';

import { createContext } from 'use-context-selector';

interface ActionSheetMenuContextProps {
  width?: number;
  dismiss: () => void;
}

export const ActionSheetMenuContext =
  createContext<ActionSheetMenuContextProps>({
    dismiss: noop,
  });
